import moment from "moment";
import { fullName, gitchaFeedLine, plural } from "@/helpers/resultsCopy";

export const NEW_HOURS = 48;
export const PREVIEW = 5;

const quoted = (title) => (title ? `"${title}"` : null);

const capitalize = (text) => (text ? text.charAt(0).toUpperCase() + text.slice(1) : text);

const networkLead = (item) => {
  const person = fullName(item.agent);
  if (item.kind === "match") {
    const place = item.address || [item.city, item.state].filter(Boolean).join(", ") || "An active listing";
    return {
      name: place,
      company: null,
      isPlace: true,
      what: item.wantListing?.title ? `Matches your Buyer Want-Listing ${quoted(item.wantListing.title)}` : "Matches one of your Buyer Want-Listings",
      about: "High-ranking match",
      unit: ["match", "matches"],
    };
  }
  const name = person || "An agent";
  if (item.kind === "intro_received") {
    return {
      name,
      company: item.agent?.company || null,
      what: `Sent you an introduction${item.address ? ` for ${item.address}` : ""}`,
      about: item.wantListing?.title ? `For your Buyer Want-Listing ${quoted(item.wantListing.title)}` : null,
      unit: ["introduction", "introductions"],
    };
  }
  if (item.kind === "intro_replied") {
    return {
      name,
      company: item.agent?.company || null,
      what: `Replied to your introduction${item.address ? ` for ${item.address}` : ""}`,
      about: item.wantListing?.title ? `Their Buyer Want-Listing ${quoted(item.wantListing.title)}` : null,
      unit: ["reply", "replies"],
    };
  }
  return {
    name,
    company: item.agent?.company || null,
    what: "Sent you a message",
    about: null,
    unit: ["message", "messages"],
  };
};

const GITCHA_UNITS = {
  message: ["message", "messages"],
  email: ["message", "messages"],
  buyer_form: ["form", "forms"],
  call: ["call tap", "call taps"],
  text: ["text tap", "text taps"],
};

const gitchaLead = (item) => {
  const name = item.name || "Someone";
  const line = gitchaFeedLine(item);
  const what = line.title.startsWith(`${name} `) ? capitalize(line.title.slice(name.length + 1)) : line.title;
  return {
    name,
    anonymous: !item.name,
    company: null,
    what,
    about: line.detail || null,
    unit: GITCHA_UNITS[item.contactType] || ["time", "times"],
  };
};

export const splitOnTitle = (text, title) => {
  if (!text || !title) return [text];
  const marker = `"${title}"`;
  const at = text.indexOf(marker);
  if (at < 0) return [text];
  return [text.slice(0, at), marker, text.slice(at + marker.length)];
};

const dayOf = (at) => (at ? moment.utc(at).local().format("YYYY-MM-DD") : "");

const dedupeKey = (item, kind) => {
  const listing = item.wantListing?.id || item.listingKey || item.address || "";
  const who =
    kind === "network"
      ? item.agent?.userId || fullName(item.agent) || item.listingKey || ""
      : item.name || item.contactId || item.id;
  const what = kind === "network" ? item.kind : item.contactType;
  return [what, who, listing, dayOf(item.at)].join("|");
};

export const isNew = (at, now = moment()) => Boolean(at) && moment(now).diff(moment.utc(at), "hours", true) < NEW_HOURS;

export const kindOf = (item, kind) => item.feedKind || kind;

const withSource = (lead, item, networkName) =>
  item.feedKind === "network"
    ? { ...lead, about: [lead.about, `${networkName} Buyer Listing Service`].filter(Boolean).join(" · ") }
    : lead;

export const buildLeads = (items = [], kind, now = moment(), networkName = "LAR") => {
  const groups = new Map();
  items.forEach((item) => {
    const key = `${kindOf(item, kind)}|${dedupeKey(item, kindOf(item, kind))}`;
    const group = groups.get(key);
    if (group) {
      group.count += 1;
      if (String(item.at || "") > String(group.item.at || "")) group.item = item;
      group.items.push(item);
    } else {
      groups.set(key, { key, item, items: [item], count: 1 });
    }
  });
  return [...groups.values()]
    .map((group) => {
      const itemKind = kindOf(group.item, kind);
      const lead = withSource(itemKind === "network" ? networkLead(group.item) : gitchaLead(group.item), group.item, networkName);
      const listing = group.item.wantListing?.id ? group.item.wantListing : null;
      return {
        ...lead,
        listing,
        key: group.key,
        item: group.item,
        items: group.items,
        count: group.count,
        repeat: group.count > 1 ? plural(group.count, lead.unit[0], lead.unit[1]) : null,
        isNew: isNew(group.item.at, now),
      };
    })
    .sort((a, b) => String(b.item.at || "").localeCompare(String(a.item.at || "")));
};
